import {
    Chart,
    CategoryScale,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    TimeScale,
    Title,
    Tooltip,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

export function registerCharts(): void {
    Chart.register(
        TimeScale,
        LinearScale,
        CategoryScale,
        LineController,
        LineElement,
        PointElement,
        Title,
        Tooltip,
        Legend,
    );
}
